"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = exports.Permission_PermissionType = exports.ContractType = void 0;
var ContractType;
(function (ContractType) {
    ContractType["AccountCreateContract"] = "AccountCreateContract";
    ContractType["TransferContract"] = "TransferContract";
    ContractType["TransferAssetContract"] = "TransferAssetContract";
    ContractType["VoteAssetContract"] = "VoteAssetContract";
    ContractType["VoteWitnessContract"] = "VoteWitnessContract";
    ContractType["WitnessCreateContract"] = "WitnessCreateContract";
    ContractType["AssetIssueContract"] = "AssetIssueContract";
    ContractType["WitnessUpdateContract"] = "WitnessUpdateContract";
    ContractType["ParticipateAssetIssueContract"] = "ParticipateAssetIssueContract";
    ContractType["AccountUpdateContract"] = "AccountUpdateContract";
    ContractType["FreezeBalanceContract"] = "FreezeBalanceContract";
    ContractType["UnfreezeBalanceContract"] = "UnfreezeBalanceContract";
    ContractType["CancelAllUnfreezeV2Contract"] = "CancelAllUnfreezeV2Contract";
    ContractType["WithdrawBalanceContract"] = "WithdrawBalanceContract";
    ContractType["UnfreezeAssetContract"] = "UnfreezeAssetContract";
    ContractType["UpdateAssetContract"] = "UpdateAssetContract";
    ContractType["ProposalCreateContract"] = "ProposalCreateContract";
    ContractType["ProposalApproveContract"] = "ProposalApproveContract";
    ContractType["ProposalDeleteContract"] = "ProposalDeleteContract";
    ContractType["SetAccountIdContract"] = "SetAccountIdContract";
    ContractType["CustomContract"] = "CustomContract";
    ContractType["CreateSmartContract"] = "CreateSmartContract";
    ContractType["TriggerSmartContract"] = "TriggerSmartContract";
    ContractType["GetContract"] = "GetContract";
    ContractType["UpdateSettingContract"] = "UpdateSettingContract";
    ContractType["ExchangeCreateContract"] = "ExchangeCreateContract";
    ContractType["ExchangeInjectContract"] = "ExchangeInjectContract";
    ContractType["ExchangeWithdrawContract"] = "ExchangeWithdrawContract";
    ContractType["ExchangeTransactionContract"] = "ExchangeTransactionContract";
    ContractType["UpdateEnergyLimitContract"] = "UpdateEnergyLimitContract";
    ContractType["AccountPermissionUpdateContract"] = "AccountPermissionUpdateContract";
    ContractType["ClearABIContract"] = "ClearABIContract";
    ContractType["UpdateBrokerageContract"] = "UpdateBrokerageContract";
    ContractType["ShieldedTransferContract"] = "ShieldedTransferContract";
    ContractType["MarketSellAssetContract"] = "MarketSellAssetContract";
    ContractType["MarketCancelOrderContract"] = "MarketCancelOrderContract";
    ContractType["FreezeBalanceV2Contract"] = "FreezeBalanceV2Contract";
    ContractType["UnfreezeBalanceV2Contract"] = "UnfreezeBalanceV2Contract";
    ContractType["WithdrawExpireUnfreezeContract"] = "WithdrawExpireUnfreezeContract";
    ContractType["DelegateResourceContract"] = "DelegateResourceContract";
    ContractType["UnDelegateResourceContract"] = "UnDelegateResourceContract";
    ContractType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ContractType || (exports.ContractType = ContractType = {}));
var Permission_PermissionType;
(function (Permission_PermissionType) {
    Permission_PermissionType[Permission_PermissionType["Owner"] = 0] = "Owner";
    Permission_PermissionType[Permission_PermissionType["Witness"] = 1] = "Witness";
    Permission_PermissionType[Permission_PermissionType["Active"] = 2] = "Active";
    Permission_PermissionType[Permission_PermissionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Permission_PermissionType || (exports.Permission_PermissionType = Permission_PermissionType = {}));
var AccountType;
(function (AccountType) {
    AccountType[AccountType["Normal"] = 0] = "Normal";
    AccountType[AccountType["AssetIssue"] = 1] = "AssetIssue";
    AccountType[AccountType["Contract"] = 2] = "Contract";
    AccountType[AccountType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AccountType || (exports.AccountType = AccountType = {}));
//# sourceMappingURL=Contract.js.map